export default {"src":"/_next/static/media/arrow_down.af745ed1.svg","height":24,"width":24};